export default __webpack_public_path__ + "assets/images/visa-white.ac87058ac18f1c49b91de4621e865163.svg";